export const ARTICLE_SIDE_SPACING_PX = '24px';

export const DEFAULT_BETWEEN_COMPONENT_SPACING_PX = '16px';
export const IMAGE_BETWEEN_COMPONENT_SPACING_PX = '24px';
export const LIST_BETWEEN_COMPONENT_SPACING_PX = '8px';
